import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiMail, FiPackage } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

function PaySuccess() {
  const { state } = useLocation();

  if (!state?.orderNumber) {
    return (
      <main className="success-page success-page--empty">
        <section className="success-hero">
          <div className="success-hero__mark">{siteConfig.logo.symbol}</div>
          <p className="eyebrow">No recent order</p>
          <h1>Your next piece<br />is still out there.</h1>
          <p>Order confirmation appears here only after completing the demo checkout.</p>
          <div className="success-actions"><Link className="button-light" to="/shop">Explore the collection</Link></div>
        </section>
      </main>
    );
  }

  const orderNumber = state.orderNumber;

  return (
    <main className="success-page">
      <section className="success-hero">
        <div className="success-hero__mark"><FiCheck /></div>
        <p className="eyebrow">Order confirmed</p>
        <h1>Thank you.<br />Your pieces are on their way.</h1>
        <p>We have sent the full confirmation to <strong>{state.email}</strong>. We will write again as soon as your order leaves our warehouse.</p>
        <div className="success-actions"><Link className="button-light" to="/shop">Continue shopping</Link><Link className="success-text-link" to="/contact">Need help?</Link></div>
      </section>

      <section className="success-details">
        <div><p className="eyebrow">Order</p><strong>{orderNumber}</strong></div>
        <div><p className="eyebrow">Total</p><strong>{formatPrice(state.total)}</strong></div>
        <div><p className="eyebrow">Delivery</p><strong>3–10 working days</strong></div>
      </section>

      <section className="success-next page-shell">
        <div><FiMail /><h2>Watch your inbox</h2><p>Your receipt and order details are already on their way. Shipping updates will follow in the same email thread.</p></div>
        <div><FiPackage /><h2>Thoughtfully packed</h2><p>Your order will arrive in recyclable, low-plastic packaging with only what is needed to protect each piece.</p></div>
      </section>
    </main>
  );
}

export default PaySuccess;
